export default {

    /** URL de Autenticacion */
    // APP_SERVER_AUTORIZE_URL: process.env.VUE_APP_SERVER_AUTORIZE_API,
    // **BASE DE CATALOGO*/
    APP_CATALOGO_API: process.env.VUE_APP_CATALOGO_API,
    /** LLAVE PUBLICA PARA ACCEDER AL CORE  */
    APIKEY : process.env.VUE_APP_APIKEY_API,

    /** BASE DE API SEGURIDAD */
    APP_AUTH_BASE : process.env.VUE_APP_AUTH_API,
    APP_CLIENT_ID : process.env.VUE_APP_SIAHE_CLIENT_ID,
    APP_SECRET_KEY : process.env.VUE_APP_SIAHE_SECRET_ID

}
